import type { TemplateExtraPage } from '@/types/builder';

// Template 1 extra pages configuration
const template1Pages: TemplateExtraPage[] = [
  {
    title: 'Downsell',
    industryName: 'template1-downsell',
    dynamicValues: [
      {
        queryKey: 'b',
        values: [
          {
            queryParamValue: 'U-1B1',
            dynamicElements: [
              {
                elementId: '__dynamic__bottle_count__',
                content: 'Final Chance: Add 2 More Bottles For Just',
              },
              {
                elementId: '__dynamic__bottle_image__',
                content: '/fortigold/bottle2.webp',
                elementType: 'src',
              },
              {
                elementId: '__dynamic__button_offer__',
                content: 'YES Add 2 More Bottles for $58',
              },
            ],
          },
          {
            queryParamValue: 'U-2B1',
            dynamicElements: [
              {
                elementId: '__dynamic__bottle_count__',
                content: 'Final Chance: Add 4 More Bottles For Just',
              },
              {
                elementId: '__dynamic__bottle_image__',
                content: '/fortigold/bottles-4.png',
                elementType: 'src',
              },
              {
                elementId: '__dynamic__button_offer__',
                content: 'YES Add 4 More Bottles for $116',
              },
            ],
          },
          {
            queryParamValue: 'U-3B1',
            dynamicElements: [
              {
                elementId: '__dynamic__bottle_count__',
                content: 'Final Chance: Add 8 More Bottles For Just',
              },
              {
                elementId: '__dynamic__bottle_image__',
                content: '/fortigold/bottles-8.png',
                elementType: 'src',
              },
              {
                elementId: '__dynamic__button_offer__',
                content: 'YES Add 8 More Bottles for $232',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Upsell',
    industryName: 'template1-upsell',
    dynamicValues: [
      {
        queryKey: 'b',
        values: [
          {
            queryParamValue: 'U-1A1',
            dynamicElements: [
              {
                elementId: '__dynamic__bottle_count__',
                content:
                  'This is your ONLY chance to secure 3 extra bottles for just $29 each — over 55% OFF.',
              },
              {
                elementId: '__dynamic__bottle_image__',
                content: '/fortigold/bottles-3.webp',
                elementType: 'src',
              },
              {
                elementId: '__dynamic__button_offer__',
                content: 'YES Add 3 More Bottles for Just $87',
              },
            ],
          },
          {
            queryParamValue: 'U-2A1',
            dynamicElements: [
              {
                elementId: '__dynamic__bottle_count__',
                content:
                  'This is your ONLY chance to secure 6 extra bottles for just $29 each — over 55% OFF.',
              },
              {
                elementId: '__dynamic__bottle_image__',
                content: '/fortigold/bottles-6.png',
                elementType: 'src',
              },
              {
                elementId: '__dynamic__button_offer__',
                content: 'YES Add 6 More Bottles for Just $174',
              },
            ],
          },
          {
            queryParamValue: 'U-3A1',
            dynamicElements: [
              {
                elementId: '__dynamic__bottle_count__',
                content:
                  'This is your ONLY chance to secure 12 extra bottles for just $29 each — over 55% OFF.',
              },
              {
                elementId: '__dynamic__bottle_image__',
                content: '/fortigold/bottles-12.png',
                elementType: 'src',
              },
              {
                elementId: '__dynamic__button_offer__',
                content: 'YES Add 12 More Bottles for Just $546',
              },
            ],
          },
        ],
      },
    ],
  },
  { title: 'Contact Us', industryName: 'template1contactUs' },
  { title: 'Thank You', industryName: 'template1Thankyou' },
  { title: 'Privacy Policy', industryName: 'template1Privacy' },
  { title: 'Terms', industryName: 'template1terms' },
  { title: 'Refund', industryName: 'template1Refund' },
  { title: 'Disclaimer', industryName: 'template1Disclaimer' },
  { title: 'VSL', industryName: 'template1VSL' },
];

// Template 2 extra pages configuration
const template2Pages: TemplateExtraPage[] = [
  {
    title: 'Upsell',
    industryName: 'template2-upsell',
    dynamicValues: [
      {
        queryKey: 'b',
        values: [
          {
            queryParamValue: 'U-1A1',
            dynamicElements: [
              {
                elementId: '__dynamic__bottle_count__',
                content:
                  'Get 3 More Bottles of Movyo for Just $87 Total (Only $29 Each)',
              },
              {
                elementId: '__dynamic__bottle_image__',
                content: '/images/movyo/dynamic-images/bottles-3.webp',
                elementType: 'src',
              },
              {
                elementId: '__dynamic__button_offer__',
                content: 'YES, ADD 3 MORE BOTTLES FOR JUST $87',
              },
            ],
          },
          {
            queryParamValue: 'U-2A1',
            dynamicElements: [
              {
                elementId: '__dynamic__bottle_count__',
                content:
                  'Get 6 More Bottles of Movyo for Just $174 Total (Only $29 Each)',
              },
              {
                elementId: '__dynamic__bottle_image__',
                content: '/images/movyo/dynamic-images/bottles-6.webp',
                elementType: 'src',
              },
              {
                elementId: '__dynamic__button_offer__',
                content: 'YES, ADD 6 MORE BOTTLES FOR JUST $174',
              },
            ],
          },
          {
            queryParamValue: 'U-3A1',
            dynamicElements: [
              {
                elementId: '__dynamic__bottle_count__',
                content:
                  'Get 12 More Bottles of Movyo for Just $546 Total (Only $29 Each)',
              },
              {
                elementId: '__dynamic__bottle_image__',
                content: '/images/movyo/dynamic-images/bottles-12.webp',
                elementType: 'src',
              },
              {
                elementId: '__dynamic__button_offer__',
                content: 'YES, ADD 12 MORE BOTTLES FOR JUST $546',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Downsell',
    industryName: 'template2-downsell',
    dynamicValues: [
      {
        queryKey: 'b',
        values: [
          {
            queryParamValue: 'U-1B1',
            dynamicElements: [
              {
                elementId: '__dynamic__bottle_count__',
                content:
                  'Get 2 More Bottles of Movyo for Just $59 Total (Only $29.50 Each)',
              },
              {
                elementId: '__dynamic__bottle_image__',
                content: '/images/movyo/dynamic-images/bottles-2.webp',
                elementType: 'src',
              },
              {
                elementId: '__dynamic__button_offer__',
                content: 'YES, ADD 2 MORE BOTTLES FOR JUST $59',
              },
            ],
          },
          {
            queryParamValue: 'U-2B1',
            dynamicElements: [
              {
                elementId: '__dynamic__bottle_count__',
                content:
                  'Get 4 More Bottles of Movyo for Just $116 Total (Only $29 Each)',
              },
              {
                elementId: '__dynamic__bottle_image__',
                content: '/images/movyo/dynamic-images/bottles-4.webp',
                elementType: 'src',
              },
              {
                elementId: '__dynamic__button_offer__',
                content: 'YES, ADD 4 MORE BOTTLES FOR JUST $116',
              },
            ],
          },
          {
            queryParamValue: 'U-3B1',
            dynamicElements: [
              {
                elementId: '__dynamic__bottle_count__',
                content:
                  'Get 8 More Bottles of Movyo for Just $232 Total (Only $29 Each)',
              },
              {
                elementId: '__dynamic__bottle_image__',
                content: '/images/movyo/dynamic-images/bottles-8.webp',
                elementType: 'src',
              },
              {
                elementId: '__dynamic__button_offer__',
                content: 'YES, ADD 8 MORE BOTTLES FOR JUST $232',
              },
            ],
          },
        ],
      },
    ],
  },
  { title: 'Thank You', industryName: 'template2-thankyou' },
  { title: 'Contact', industryName: 'template2-contact' },
  { title: 'Privacy Policy', industryName: 'template2-privacy-policy' },
  { title: 'Terms', industryName: 'template2-terms' },
  { title: 'Returns', industryName: 'template2-returns' },
  { title: 'Disclaimer', industryName: 'template2-disclaimer' },
  { title: 'VSL', industryName: 'template2VSL' },
];

// Template 3 extra pages configuration
const template3Pages: TemplateExtraPage[] = [
  { title: 'Upsell', industryName: 'templateUpsell3' },
  { title: 'Downsell', industryName: 'templateDownsell3' },
  { title: 'Thank You', industryName: 'template3thankyou' },
  { title: 'Contact Us', industryName: 'template3contactUs' },
  { title: 'Privacy Policy', industryName: 'template3PrivacyPolicy' },
  { title: 'Terms', industryName: 'template3terms' },
  { title: 'Refund', industryName: 'template3refund' },
  { title: 'Disclaimer', industryName: 'template3disclaimer' },
];

// Template 4 extra pages configuration
const template4Pages: TemplateExtraPage[] = [
  { title: 'Upsell', industryName: 'template4-upsell' },
  { title: 'Downsell', industryName: 'template4-downsell' },
];

// Export the full configuration object
export const TEMPLATE_EXTRA_PAGES: Record<string, TemplateExtraPage[]> = {
  template1: template1Pages,
  template2: template2Pages,
  template3: template3Pages,
  template4: template4Pages,
};

// Get extra pages for a template
export const getTemplateExtraPages = (
  templateName: string
): TemplateExtraPage[] => {
  return TEMPLATE_EXTRA_PAGES[templateName] || [];
};
